import { w as n } from "../internals/well-known-symbol-define.js";
n("asyncIterator");